import React from 'react';

import { CarModelCompareLandingContextType } from './types';

export const CarModelCompareLandingContext = React.createContext(
  {} as CarModelCompareLandingContextType
);
